
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.495 13.1a1 1 0 00-1.34.45A8 8 0 119.995 2a7.93 7.93 0 017.16 4.45 1.006 1.006 0 001.8-.9 10 10 0 100 8.9 1 1 0 00-.46-1.35zm.5-4.1h-9.59l2.3-2.29a1.005 1.005 0 00-.71-1.714 1.004 1.004 0 00-.71.294l-4 4a1 1 0 00-.21.33 1 1 0 000 .76 1 1 0 00.21.33l4 4a1.002 1.002 0 001.64-.325 1 1 0 00-.22-1.095L9.405 11h9.59a1 1 0 100-2z"}})])
          )
        }
      }
    